export default __webpack_public_path__ + "static/media/CONSENTIMIENTO-INFORMADO-TRATAMIENTO-MEDICO-CANCER.de06b5d2.pdf";